/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tripCreatorSuggestTrips: "trip-creator-suggest-trips",
  tripCreatorCreate: "trip-creator-create",

  tripCreatorShipmentDropTarget: "trip-creator-shipment-drop-target",
} as const;
